module.exports = __webpack_public_path__ + "static/img/service6.3746b8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/service/service6.png
// module id = +IQx
// module chunks = 2